import template from './event-edit-modal.tpl.html'

class EventEditModalController {
  constructor ($scope, $element) {
    'ngInject'
    this._$scope = $scope
    this._$element = $element
    this.localEvent = null
  }

  $onChanges (changes) {
    if (changes.event && this.event) {
      // Clone the event to avoid mutating the parent's state directly
      // We need to ensure dates are proper Date objects or strings as expected by the inputs
      // Assuming the parent passes an object that is ready for the form or we might need conversion
      // The original code used ng-model directly on editingEvent properties.
      // Let's do a shallow copy for now.
      this.localEvent = angular.copy(this.event)

      // Ensure date objects for date inputs if they are strings
      if (typeof this.localEvent.startDate === 'string') {
        this.localEvent.startDate = new Date(this.localEvent.startDate)
      }
      if (typeof this.localEvent.endDate === 'string') {
        this.localEvent.endDate = new Date(this.localEvent.endDate)
      }
      // Time inputs usually expect Date objects in AngularJS or specific string formats depending on browser
      // But looking at the original template: <input type="time" ... ng-model="$ctrl.editingEvent.startTime">
      // If it was working before, we should try to maintain the same data type.
      // However, angular.copy might break object references if they were moment objects.
      // Let's assume standard JS Date objects or strings.

      // If the original used moment objects, we might need to convert them to JS Dates for ng-model with input[type=date/time]
      // The original code didn't show explicit conversion in the template, so it likely relied on the controller to prep the data.
      // We will assume `this.event` comes in prepared.
    }
  }

  save () {
    this.onSave({ $event: this.localEvent })
  }

  delete () {
    this.onDelete({ $event: this.event })
  }

  cancel () {
    this.onClose()
  }
}

export const EventEditModalComponent = {
  template,
  controller: EventEditModalController,
  bindings: {
    show: '<',
    event: '<',
    onClose: '&',
    onSave: '&',
    onDelete: '&'
  }
}
